import React from "react";

export default function Spinner() {
  return (
    <div className="bg-black bg-opacity-50 flex items-center justify-center fixed left-0 right-0 bottom-0 top-0 z-50">
      
      <div className="relative w-28 h-28 flex items-center justify-center">

        {/* Left Sail */}
        <div className="sail-left absolute"></div>

        {/* Right Sail */}
        <div className="sail-right absolute"></div>

        {/* Boat Base */}
        <div className="boat-base absolute"></div>

      </div>
    </div>
  );
}


const styles = `
:root{
  --boat-blue:#2EA3DB;
}

/* LEFT SAIL */
.sail-left{
  width:0;
  height:0;
  border-left:40px solid transparent;
  border-right:40px solid transparent;
  border-bottom:115px solid var(--boat-blue); /* increased */

  position:absolute;
  top:-10px;
  left:6px;

  transform-origin:bottom right;
  animation:sailLeft 2s ease-in-out infinite;
}

/* RIGHT SAIL */
.sail-right{
  width:0;
  height:0;
  border-left:40px solid transparent;
  border-right:40px solid transparent;
  border-bottom:95px solid var(--boat-blue); /* increased */

  position:absolute;
  top:5px;
  right:6px;

  transform-origin:bottom left;
  animation:sailRight 2s ease-in-out infinite;
}

/* BOAT BASE */
.boat-base{
  width:140px;
  height:18px;
  background:var(--boat-blue);
  bottom:-30px;
  border-radius:0 0 30px 30px;
}

/* SAIL MOVEMENTS */

@keyframes sailLeft{
  0%{ transform:rotate(0deg); }
  50%{ transform:rotate(-6deg); }
  100%{ transform:rotate(0deg); }
}

@keyframes sailRight{
  0%{ transform:rotate(0deg); }
  50%{ transform:rotate(6deg); }
  100%{ transform:rotate(0deg); }
}
`;

const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);